import { render, staticRenderFns } from "./noPermission.vue?vue&type=template&id=5a0d0f92&scoped=true"
import script from "./noPermission.vue?vue&type=script&lang=js"
export * from "./noPermission.vue?vue&type=script&lang=js"
import style0 from "./noPermission.vue?vue&type=style&index=0&id=5a0d0f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d0f92",
  null
  
)

export default component.exports